<template>
    <transition name="slide" mode="out-in">
        <div 
            class="wrapper--corner-buttons has-overflow"
            style="--slide-offset: -9em"
            v-bind="$attrs"
            v-show="visible"
        >
            <OpeningsCta v-bind="{ tabindex }" />
        </div>
    </transition>
</template>

<script>
import OpeningsCta from '@/components/Discover/OpeningsCta'

export default {
    
    props: {
        visible: {
            type: [String, Boolean],
            default: false
        },
        tabindex: [Boolean, Number],
    },
    
    components: {
        OpeningsCta,
    },
}
</script>